var map = {
	"./any.png": 55,
	"./asparagus.png": 56,
	"./banana.png": 57,
	"./barnacle.png": 58,
	"./berries.png": 59,
	"./birchnut.png": 60,
	"./bluecap.png": 61,
	"./boneshards.png": 62,
	"./butter.png": 63,
	"./butterflywings.png": 64,
	"./cactus.png": 65,
	"./cactusflower.png": 66,
	"./carrot.png": 67,
	"./collecteddust.png": 68,
	"./corn.png": 69,
	"./dairy.png": 70,
	"./dragonfruit.png": 71,
	"./drumstick.png": 72,
	"./durian.png": 73,
	"./eel.png": 74,
	"./egg.png": 75,
	"./eggplant.png": 76,
	"./electricmilk.png": 77,
	"./fig.png": 78,
	"./fishes.png": 79,
	"./fishmeat.png": 80,
	"./fishmorsel.png": 81,
	"./forgetmelots.png": 82,
	"./frame.png": 8,
	"./freshwaterfish.png": 83,
	"./froglegs.png": 84,
	"./fruits.png": 85,
	"./fruitsandveggies.png": 86,
	"./garlic.png": 87,
	"./glowberry.png": 88,
	"./greencap.png": 89,
	"./honey.png": 90,
	"./ice.png": 91,
	"./kelpfronds.png": 92,
	"./koalefanttrunks.png": 93,
	"./leafymeat.png": 94,
	"./lesserglowberry.png": 95,
	"./lichen.png": 96,
	"./liveeel.png": 97,
	"./mandrake.png": 98,
	"./meat.png": 99,
	"./meats.png": 100,
	"./moleworm.png": 101,
	"./monsterfoods.png": 102,
	"./monstermeat.png": 103,
	"./moonshroom.png": 104,
	"./morsel.png": 105,
	"./nakednostrils.png": 106,
	"./nightmarefuel.png": 107,
	"./onion.png": 108,
	"./pepper.png": 109,
	"./pomegranate.png": 110,
	"./potato.png": 111,
	"./pumpkin.png": 112,
	"./redcap.png": 113,
	"./roastedbirchnut.png": 114,
	"./royaljelly.png": 115,
	"./seaweed.png": 116,
	"./stonefruit.png": 117,
	"./tallbirdegg.png": 118,
	"./toma.png": 119,
	"./twigs.png": 120,
	"./vegetables.png": 121,
	"./voltgoathorn.png": 122,
	"./watermelon.png": 123,
	"./wobster.png": 124
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2;